import { render, staticRenderFns } from "./NormalSearchNav197.vue?vue&type=template&id=27d56a62&scoped=true"
import script from "./NormalSearchNav197.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav197.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d56a62",
  null
  
)

export default component.exports